module.exports = __webpack_public_path__ + "static/media/myavatar.ce26181a.gif";